import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import OrderArticleInfo from './OrderArticleInfo'
import OrderPaletInfo from './OrderPaletInfo'
import OrderState from './OrderState'
import Box from '@material-ui/core/Box';

export default function Order(props) {
    const classes = useStyles();


    return <div className={classes.orderContainer}>
        <div className={classes.coloredBorder} style={{ backgroundColor: props.productionOrder.productionOrderStatusForegroundColor }}></div>
        <Box style={{ width: 'calc(100% - 7px)', display: 'flex', flexDirection: 'row' }}>
            <OrderState productionOrder={props.productionOrder} openSwitchRawMaterialDialog={props.openSwitchRawMaterialDialog} setReload={props.setReload} {...props}></OrderState>
            <OrderArticleInfo productionOrder={props.productionOrder} {...props}></OrderArticleInfo>
            <OrderPaletInfo productionOrder={props.productionOrder} {...props}></OrderPaletInfo>
        </Box>

    </div>
}

const useStyles = makeStyles({
    orderContainer: {
        backgroundColor: "white",
        borderRadius: "6px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        display: 'flex',
        flexDirection: 'row'

    },
    coloredBorder: {
        float: "left",
        width: "7px",
        borderRadius: "6px 0px 0px 6px",
        opacity: "0.28",
        display: 'flex',
        flexDirection: 'column'
    }

});